import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
function ForgotPassword({ open, handleClose , otp , setOtp , verify }) {
  const {error} = useSelector((state)=>state.otp)
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            handleClose();
          },
          sx: { backgroundImage: 'none' },
        },
      }}
    >
      <DialogTitle>Email Verification.</DialogTitle>
      <DialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}
      >
        <DialogContentText>
          Enter Your OTP&apos;we sent you on your email to
          verify.
        </DialogContentText>
        <OutlinedInput
          autoFocus
          required
          margin="dense"
          id="otp"
          name="otp"
          label="OTP"
          placeholder="eg 3456"
          type="email"
          onChange={(e)=>{setOtp(e.target.value)}}
          fullWidth
        />
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3}}>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={(e)=>verify(e)} variant="contained" type="submit">
          Verify
        </Button>

      </DialogActions>
      <Typography  variant = 'subtitle2' sx={{color : 'red' , alignSelf : 'center'}} >{error}</Typography>


      
    </Dialog>
  );
}

ForgotPassword.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default ForgotPassword;